// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* put this in src/styles/theme.css */
.ag-header-cell-label {
  justify-content: center !important;  /* center horizontally */
  align-items: center !important;      /* center vertically */
  text-align: center !important;       /* backup */
}

/* theme.css */
.header-center .ag-header-cell-label {
  justify-content: center !important;
  align-items: center !important;
}

.row-highlight-pending {
  background-color: #cce5ff; /* light blue */
}

.row-highlight-running {
  background-color: #fff3cd; /* light yellow */
}

.row-highlight-complete {
  background-color: #d4edda; /* light green */
}

.row-highlight-failed {
  background-color: #f8d7da; /* light red */
}

/* .status-pending { background-color: #cce5ff; color: #004085; font-weight: bold; text-align: center; }
.status-running { background-color: #fff3cd; color: #856404; font-weight: bold; text-align: center; }
.status-completed { background-color: #d4edda; color: #155724; font-weight: bold; text-align: center; }
.status-failed { background-color: #f8d7da; color: #721c24; font-weight: bold; text-align: center; } */


/* {
  headerName: "Status",
  field: "status",
  cellClass: (params) => {
    switch(params.value) {
      case "Pending": return "status-pending";
      case "Running": return "status-running";
      case "Completed": return "status-completed";
      case "Failed": return "status-failed";
      default: return "";
    }
  }
} */

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px; /* pill shape */
  font-weight: bold;
  font-size: 0.85rem;
  color: white; /* default text color */
  text-align: center;
  width: 110px;           /* fixed width so all are the same size */
}

.status-pending { background-color: #6c757d; }   /* gray */
.status-downloading { background-color: #007bff; }   /* blue */
.status-running { background-color: #ffc107; }   /* yellow/orange */
.status-completed { background-color: #28a745; } /* green */
.status-failed { background-color: #dc3545; }    /* red */

.job-details-highlight {
  background-color: #f3f8f8; /* translucent red highlight */
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kCAAkC,GAAG,wBAAwB;EAC7D,8BAA8B,OAAO,sBAAsB;EAC3D,6BAA6B,QAAQ,WAAW;AAClD;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;;;sGAGsG;;;AAGtG;;;;;;;;;;;;GAYG;;AAEH;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB,EAAE,eAAe;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY,EAAE,uBAAuB;EACrC,kBAAkB;EAClB,YAAY,YAAY,yCAAyC;AACnE;;AAEA,kBAAkB,yBAAyB,EAAE,IAAI,SAAS;AAC1D,sBAAsB,yBAAyB,EAAE,IAAI,SAAS;AAC9D,kBAAkB,yBAAyB,EAAE,IAAI,kBAAkB;AACnE,oBAAoB,yBAAyB,EAAE,EAAE,UAAU;AAC3D,iBAAiB,yBAAyB,EAAE,KAAK,QAAQ;;AAEzD;EACE,yBAAyB,EAAE,8BAA8B;AAC3D","sourcesContent":["/* put this in src/styles/theme.css */\n.ag-header-cell-label {\n  justify-content: center !important;  /* center horizontally */\n  align-items: center !important;      /* center vertically */\n  text-align: center !important;       /* backup */\n}\n\n/* theme.css */\n.header-center .ag-header-cell-label {\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.row-highlight-pending {\n  background-color: #cce5ff; /* light blue */\n}\n\n.row-highlight-running {\n  background-color: #fff3cd; /* light yellow */\n}\n\n.row-highlight-complete {\n  background-color: #d4edda; /* light green */\n}\n\n.row-highlight-failed {\n  background-color: #f8d7da; /* light red */\n}\n\n/* .status-pending { background-color: #cce5ff; color: #004085; font-weight: bold; text-align: center; }\n.status-running { background-color: #fff3cd; color: #856404; font-weight: bold; text-align: center; }\n.status-completed { background-color: #d4edda; color: #155724; font-weight: bold; text-align: center; }\n.status-failed { background-color: #f8d7da; color: #721c24; font-weight: bold; text-align: center; } */\n\n\n/* {\n  headerName: \"Status\",\n  field: \"status\",\n  cellClass: (params) => {\n    switch(params.value) {\n      case \"Pending\": return \"status-pending\";\n      case \"Running\": return \"status-running\";\n      case \"Completed\": return \"status-completed\";\n      case \"Failed\": return \"status-failed\";\n      default: return \"\";\n    }\n  }\n} */\n\n.status-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px; /* pill shape */\n  font-weight: bold;\n  font-size: 0.85rem;\n  color: white; /* default text color */\n  text-align: center;\n  width: 110px;           /* fixed width so all are the same size */\n}\n\n.status-pending { background-color: #6c757d; }   /* gray */\n.status-downloading { background-color: #007bff; }   /* blue */\n.status-running { background-color: #ffc107; }   /* yellow/orange */\n.status-completed { background-color: #28a745; } /* green */\n.status-failed { background-color: #dc3545; }    /* red */\n\n.job-details-highlight {\n  background-color: #f3f8f8; /* translucent red highlight */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
